import { AppUpdate } from "@capawesome/capacitor-app-update"
import {
	APP_STORE_ID,
	APP_STORE_URL,
	detectStore,
	GOOGLE_PLAY_URL,
	RUSTORE_APP_URL,
} from "@/shared/lib/platform"

const store = detectStore()

export async function openAppStore(): Promise<void> {
	if (store === "rustore") {
		window.location.href = RUSTORE_APP_URL
		return
	}
	try {
		await AppUpdate.openAppStore({
			appId: APP_STORE_ID,
			androidStorePackageName: "com.android.vending",
		})
	} catch (error) {
		if (store === "app-store") {
			window.location.href = APP_STORE_URL
			return
		}
		if (store === "google-play") {
			window.location.href = GOOGLE_PLAY_URL
			return
		}
		throw error
	}
}
